<template>
  <div>
    <v-sheet class="ml-2 transparent">
      <v-slide-group center-active show-arrows>
        <v-slide-item v-for="(time,idx) in current_execution.all_times" :key="'ckind6'+time" v-slot:default="{ active, toggle }">
          <v-card style="border-radius:8px; cursor:pointer" 
            :class="['mx-2 my-1', local_current_time==time? 'light-green accent-3':'']" 
            :key="'card'+idx" @click="writeCurrentTime(time, idx)"
          >
            <v-card-text class="pa-2" :class="[local_current_time==time? 'black--text':'']">
              <div class="subtitle-2">{{time}}</div>
            </v-card-text>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'SelectTime',
  data() {
    return {
      key: null,
      local_current_time: null,
      local_current_time_idx: null,
      time_spacing: {
        value: 20,
        unit: 'minutes',
      },
      all_times: [],
      all_times_obj: []
    }
  },
  methods: {
    setupAllTimes(){
      this.local_current_time = this.current_time || this.current_execution.all_times[0]
      this.local_current_time_idx = this.current_time_idx || 0
    },
    writeCurrentTime(time, idx) {
      this.local_current_time = time
      this.local_current_time_idx = idx
    },
    ...mapActions({
      // function: 'Module/action'
    }),
    ...mapMutations({
      setExecutionModel1: 'Execution/setExecutionModel1',
      setCurrentTime: 'Execution/setCurrentTime',
      setCurrentTimeIdx: 'Execution/setCurrentTimeIdx',
    })
  },
  mounted () {
    // this.setExecutionModel1()
    this.setupAllTimes();
  },
  computed: {
    current_exec_has_interval_set() {
      if (this.current_execution){
        if (this.current_execution.job_interval.start && this.current_execution.job_interval.end){
          return true
        }
      }
      return false 
    },
    ...mapState({
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      profile: state => state.User.profile,
      // data: state=> state.Module.state_var
    }),
  },
  watch: {
    local_current_time(nv, ov) {
      if(nv){
        this.setCurrentTime(nv)
      }
    },
    local_current_time_idx(nv, ov) {
      this.setCurrentTimeIdx(nv)
      if(nv){
      }
    }
  },

}
</script>

<style lang="scss" scoped>

</style>